import React from "react";
import "./devider.scss";

export const Devider = () => {
	return <div className="devider" />;
};
